var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isStale)?_c('div',{staticClass:"penalty-recalc-stale-text red--text"},[_vm._v(" "+_vm._s(_vm.message)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }